/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class UserPhoneDtoModel  {

  uuid: string | null = null;

  phoneNumber: string | null = null;

  validated: boolean | null = null;

  twoFactorAuthEnabled: boolean | null = null;

}
